const APP_ACTION_TYPES = {
  // common
  UPDATE_SHARE_INFO: 'UPDATE_SHARE_INFO',
  IS_SENSOR_INIT: 'IS_SENSOR_INIT',
  UPDATE_PLATFROM: 'UPDATE_PLATFROM',
  UPDATE_DEVICE: 'UPDATE_DEVICE',

  // work
  GET_WORK_DETAIL: 'GET_WORK_DETIAL',
  GET_RECOMMEND_TEMPLATE: 'GET_RECOMMEND_TEMPLATE',
};

export { APP_ACTION_TYPES };
